import { SearchFilter } from './search-v2-filter';

export class SearchbarState {
    public query = '';
    public filters: SearchFilter[] = [];
}
